export const CENTERED_DROPDOWNS_TYPES = ['copy trading']
